import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    placeholder: translate({ id: 'vehicles.form.exceptions.filterPlaceholder' }),
  }))

  return api
}
